import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const AssigneeBox = styled.div`
    padding: 14px 16px;
    border-radius: 12px;
    display: flex;
    width: 100%;
    background-color: ${color.emphasis.NEUTRAL_N0};
    box-sizing: border-box;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .left {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .title {
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            color: ${color.secondary.DARK_GREY};
            line-height: 20px;
        }

        .content {
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 22px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            padding: 6px 10px;
            border-radius: 8px;
            transition: background-color 120ms ease-in-out;
            
            .primary-badge {
                font-size: 11px;
                line-height: 16px;
                padding: 2px 6px;
                border-radius: 999px;
                background-color: ${color.primary.BLUE_B100}15;
                color: ${color.primary.BLUE_B100};
                border: 1px solid ${color.primary.BLUE_B100}30;
                text-transform: uppercase;
                letter-spacing: 0.02em;
            }

            .assignee-item {
                display: inline-flex;
                align-items: center;
                gap: 6px;
            }
            .assignee-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 16px;
                height: 16px;
                opacity: 0.8;
                
                svg {
                    width: 16px;
                    height: 16px;
                }
            }
            .assignee-text {
                display: inline-flex;
                align-items: baseline;
                gap: 6px;
            }
            .assignee-name {
                color: ${color.secondary.CHARCOAL};
            }
            .assignee-email {
                font-size: 12px;
                color: ${color.emphasis.NEUTRAL_N70};
            }
            .assignee-sep {
                margin: 0 4px;
                color: ${color.emphasis.NEUTRAL_N50};
            }
        }
        .content:hover {
            background-color: ${color.secondary.GREY_1};
        }
        .content.locked:hover {
            background-color: transparent;
        }
        .content.locked {
            cursor: default;
        }
    }

    .right {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
`;

interface AssigneeSearchProps {
    isFocus: boolean;
}

export const AssigneeSearch = styled.div<AssigneeSearchProps>`
    display: flex;
    height: 40px;
    justitfy-content: space-between;

    padding: 8px 16px 8px 16px;
    box-sizing: border-box;
    border-radius: 24px;
    width: 216px;
    background: white;
    border: solid 1px ${color.secondary.BORDER};
`;

export const StyledInput = styled.input`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    border: none;

    &::placeholder {
        color: ${color.emphasis.NEUTRAL_N30};
    }

    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
`;
